"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import { TimerEngine } from "@/utils/settimeout";
import i18n from "@/lang";
class AuthFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.auth_id = "";
    this.verify_code = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("phonebind.please_enter_your_mobile_phone_number"),
      trigger: "blur"
    }
  ])
], AuthFormController.prototype, "auth_id", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("phonebind.please_enter_the_verification_code"),
      trigger: "blur"
    }
  ])
], AuthFormController.prototype, "verify_code", 2);
let PhoneBind = class extends Vue {
  constructor() {
    super(...arguments);
    this.verifyCodeTimer = 90;
    this.verifyCodeSend = false;
    this.authFormController = new AuthFormController();
  }
  mounted() {
    let _timer = parseInt(sessionStorage.getItem("verifyCodeTimer"));
    if (!isNaN(_timer)) {
      this.getVerifyCode(_timer);
    }
  }
  onNext() {
    this.$router.push("/test");
  }
  getVerifyCode(time = 90) {
    this.verifyCodeTimer = time;
    this.verifyCodeSend = true;
    const _verifyCode = new TimerEngine(() => __async(this, null, function* () {
      this.verifyCodeTimer = this.verifyCodeTimer - 1;
      sessionStorage.setItem("verifyCodeTimer", this.verifyCodeTimer.toString());
      if (this.verifyCodeTimer <= 0) {
        _verifyCode.stop();
        this.verifyCodeSend = false;
        this.verifyCodeTimer = 90;
      }
    }), 1e3);
    _verifyCode.start();
  }
  authSubmit() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
      } finally {
        this.authFormController.complete();
      }
    });
  }
};
PhoneBind = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit
    }
  })
], PhoneBind);
export {
  PhoneBind as default
};
